import React from "react";
import ArmageddonImage from "../../../../assets/images/CT/armageddon.png";
import SnakeEyes from "../../../../assets/images/CT/snakeEyes.png";
import MagicNumber from "../../../../assets/images/CT/magicNumber.png";
import HighFive from "../../../../assets/images/CT/highFive.png";
import TwoPair from "../../../../assets/images/CT/Twopair.png";
import FourThought from "../../../../assets/images/CT/FourThought.png";
import { connect } from "react-redux";
import _ from "lodash";

const Doubles = (props) => {
  const playingParams = _.get(props, "paramsReducer.gameObj.2_playing");
  const doubles_1 = _.get(playingParams, "doubles_1");
  const doubles_2 = _.get(playingParams, "doubles_2");
  const doubles_3 = _.get(playingParams, "doubles_3");
  const doubles_4 = _.get(playingParams, "doubles_4");
  const doubles_5 = _.get(playingParams, "doubles_5");
  const doubles_6 = _.get(playingParams, "doubles_6");
  const {
    dice_ob,
    active_player_details,
    discard_pile,
    any_other_player_has_cards,
    // card_stolen_from_player,
    // type_of_card_stolen,
    card_stolen_from,
    users,
  } = props;
  const dice = dice_ob?.dice;
  // const dice = [6];
  const dice_special = _.get(dice_ob, "dice_special", null);
  const given_card = _.get(dice_ob, "given_card");

  return (
    <>
      {dice[0] === 1 && (
        <div className="armageddon-screen">
          <div className="arm-image">
            <img src={SnakeEyes} alt="" />
            <p className="name">{doubles_1.title}</p>
          </div>

          <h2>
            {active_player_details?.display_name}
            <br /> {doubles_1.headline}
          </h2>
          <p className="a-text">{doubles_1.info}</p>
        </div>
      )}
      {dice[0] === 2 && (
        <div className="armageddon-screen">
          <div className="arm-image">
            <img src={TwoPair} alt="" />
            <p className="name">{doubles_2.title}</p>
          </div>

          <h2>
            {active_player_details?.display_name}
            <br /> {doubles_2.headline}
          </h2>
          <p className="a-text">{doubles_2.info}</p>
        </div>
      )}
      {dice[0] === 3 && (
        <div className="armageddon-screen">
          <div className="arm-image">
            <img src={MagicNumber} alt="" />
            <p className="name">{doubles_3.title}</p>
          </div>

          <h2>
            {active_player_details?.display_name}
            <br /> {doubles_3.headline}
          </h2>
          <p className="a-text">
            {discard_pile.length === 0
              ? doubles_3.info_empty
              : `${doubles_3.info_1}${given_card}
            ${doubles_3.info_2}`}
          </p>
        </div>
      )}
      {dice[0] === 4 && (
        <div className="armageddon-screen">
          <div className="arm-image">
            <img src={FourThought} alt="" />
            <p className="name">{doubles_4.title}</p>
          </div>

          <h2>
            {active_player_details?.display_name}
            <br /> {doubles_4.headline}
          </h2>
          <p className="a-text">{doubles_4.info}</p>
        </div>
      )}
      {dice[0] === 5 && (
        <div className="armageddon-screen">
          <div className="arm-image">
            <img src={HighFive} alt="" />
            <p className="name">{doubles_5.title}</p>
          </div>
          <h2>
            {active_player_details?.display_name}
            <br /> {doubles_5.headline}
          </h2>
          <p className="a-text">
            {!any_other_player_has_cards()
              ? doubles_5.info_empty
              : card_stolen_from === null
              ? doubles_5.info
              : `${doubles_5.info_1}${card_stolen_from.card_type}${doubles_5.info_2}${
                  _.find(users, { player_id: card_stolen_from?.player_id })?.display_name
                }`}
          </p>
        </div>
      )}
      {dice[0] === 6 && (
        <div className="armageddon-screen armageddon-screen-wrapper">
          <div className="arm-image">
            <img src={ArmageddonImage} alt="" />
            <p className="name">{doubles_6.title}</p>
          </div>

          <h2 className="armageddon-h2">
            {active_player_details?.display_name}
            <br />
            {dice_special === null
              ? doubles_6.headline_1
              : dice_special === 6
              ? doubles_6.headline_6_1
              : doubles_6.headline_0_1}
          </h2>
          <h3 className="headlines">
            {dice_special === null
              ? doubles_6.headline_2
              : dice_special === 6
              ? doubles_6.headline_6_2
              : doubles_6.headline_0_2}
          </h3>
          <p className="a-text">
            {dice_special === null ? doubles_6.info : dice_special === 6 ? doubles_6.info_6 : doubles_6.info_0}
          </p>
        </div>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Doubles);
